import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Stack,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import EmailIcon from '@mui/icons-material/Email';

import founder1 from '../assets/eddy.jpeg';
import founder2 from '../assets/barry.jpeg';

const team = [
  {
    name: 'Ed Byrne',
    title: 'Co-Founder & CEO',
    bio: 'Ed started his career at Merrill Lynch, experiencing firsthand the inefficiencies in client acquisition for financial advisors and the opaqueness of prospecting data. At Morningstar, he ran prospecting across all licensed SaaS and data products. Empowering thousands of advisors while doing so. Now he wants to revolutionize the way wealth prospecting is done by building Pathvizor.',
    img: founder1,
    linkedin: 'https://www.linkedin.com/in/edward-byrne-676700136',
    email: 'alex@example.com',
  },
  {
    name: 'Jiazhao Wu',
    title: 'Co-Founder & CTO',
    bio: "Jiazhao is a Staff Software Engineer at Cisco. He studied Mathematics at Northwestern University and is obsessed with building stuff. Since meeting Ed at Chicago's 1871 FinTech showcase, they began building Pathvizor.",
    img: founder2,
    linkedin: 'https://www.linkedin.com/in/jiazhao-wu-b698b034b',
    email: 'jamie@example.com',
  },
];

const AboutPage = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ py: 10, backgroundColor: '#f9f9f9' }}>
      <Container maxWidth="md">
        <Typography variant="h4" fontWeight={600} gutterBottom align="center">
        About Pathvizor
        </Typography>

        <Typography variant="body1" color="textSecondary" mb={6} align="center">
        Pathvizor is revolutionizing how early-career financial advisors prospect and grow their business. Our platform provides precise wealth segmentation, timely financial event insights, and exclusive data to help advisors connect with the right clients at exactly the right time.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            gap: 4,
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          {team.map((member, i) => (
            <Card
              key={i}
              elevation={2}
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                p: 4,
                minWidth: 280,
              }}
            >
              <Avatar
                src={member.img}
                alt={member.name}
                sx={{ width: 130, height: 130, mb: 2 }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {member.name}
                </Typography>
                <Typography variant="body2" color="textPrimary" mb={2}>
                  {member.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" mb={2}>
                  {member.bio}
                </Typography>
                <Stack direction="row" spacing={1} justifyContent="center">
                  <IconButton
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener"
                    aria-label="LinkedIn"
                  >
                    <LinkedInIcon />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default AboutPage;
